import classNames from "classnames/bind";

import UIIcon from "../UIIcon";
import styles from "./Info.module.scss";

const cx = classNames.bind(styles);

export type InfoProps = {
    children: React.ReactNode;
    className?: string;
};

const Info = (props: InfoProps) => {
    return (
        <div className={cx("info", props.className)}>
            <span className={cx("icon")}>
                <UIIcon icon="Info" />
            </span>
            <div>{props.children}</div>
        </div>
    );
};

export default Info;
